<template>
  <el-form ref="formData" :model="formData" :rules="rules" size="medium" v-loading="loading">
    <el-form-item prop="name" :label="$t('users.name')" required>
      <el-input
        class="no-border input-lg"
        v-model="formData.name"
        prefix-icon="el-icon-user"
      >
      </el-input>
    </el-form-item>
    <el-form-item prop="email" :label="$t('users.email')" required>
      <el-input
        class="no-border input-lg"
        v-model="formData.email"
        prefix-icon="el-icon-message"
      >
      </el-input>
    </el-form-item>
    <el-form-item prop="password" :label="$t('login.password')" required>
      <el-input
        class="no-border input-lg"
        type="password"
        v-model="formData.password"
        prefix-icon="now-ui-icons objects_key-25"
        show-password>
      </el-input>
    </el-form-item>
    <el-form-item prop="phone" :label="$t('users.phone')">
      <el-input
        class="no-border input-lg"
        v-model="formData.phone"
        prefix-icon="el-icon-phone-outline"
      >
      </el-input>
    </el-form-item>
    <el-form-item prop="accept" required>
      <el-checkbox v-model="formData.accept">{{$t('users.terms_conditions')}}</el-checkbox>
    </el-form-item>
    <el-form-item prop="recaptcha" required>
      <vue-recaptcha 
        sitekey="6LeEqMEUAAAAAFQHY5HAmaZ4hB7bg9pcxX5FfF1I"
        ref="formData.recaptcha"
        @verify="onVerify"
        @expired="onExpired"
      ></vue-recaptcha>
    </el-form-item>
    <div class="text-center">                
      <el-button class="btn-primary btn btn-lg" size="large" round type="primary" @click="onLoginSubmit()">{{$t('signup.button')}}</el-button>
      <h4>
        <el-link icon="el-icon-user" type="info" @click="showLoginModal">{{$t('menu.login')}}</el-link>
      </h4>
    </div>
  </el-form>
</template>
<script>
import { Card, Alert } from '@/components';
import { Input, Button, Form, FormItem, Link, Checkbox, Message } from 'element-ui';
import VueRecaptcha from 'vue-recaptcha';

import Auth from '@/providers/Auth'

const AuthProvider = new Auth()

export default {
  components: {
    Card,
    [Input.name]: Input,
    [Form.name]: Form,
    [FormItem.name]: FormItem,
    [Button.name]: Button,
    [Link.name]: Link,
    [Checkbox.name]: Checkbox,
    Alert,
    VueRecaptcha
  },
  data() {
    return {
      user: {
        terms: false,
        qualify: false
      },
      formData: {
        name: null,
        email: null,
        password: null,
        password_again: null,
        phone: null,
        locale: this.$i18n.locale,
        accept: null,
        recaptcha: null
      },
      rules: {
        name: [{ required: true, message: 'Nombre completo es obligatorio', trigger: 'blur' }],
        email: [{ required: true, message: 'Ingresa un correo electrónico', trigger: 'blur', type: 'email' }],
        password: [{ required: true, message: 'Ingresa una contraseña', trigger: 'blur' }],
        accept: [{ required: true, message: 'Acepta los términos y condiciones', trigger: 'change' }],
        recaptcha: [{ required: true, message: 'Resuelve el recaptcha', trigger: 'change' }]
      },
      loading: false,
      error: null
    }
  },
  methods: {
    onLoginSubmit () {
      this.$refs['formData'].validate((valid) => {
          if (valid) {
            if (this.formData.recaptcha) {
              this.loading = true
              delete this.formData.password_again
              AuthProvider.register(this.formData).then((resp)=> {
                this.error = null
                setTimeout(() => {
                    this.loading = false
                    this.$router.push('/unconfirmed')
                }, 3000);
              }).catch((err)=>{
                this.loading = false
                if (err && err.status && (err.status === 400)) {
                  Message({ type: 'error', message: 'Verify data' })
                } else {
                  Message({ type: 'error', message: 'Error comunication' })
                }
              }) 
            } else {
              
            }
          } else {
            return false;
          }
      })
    },
    onVerify(response) {
      this.formData.recaptcha = true
    },
    onExpired () {
      this.formData.recaptcha = null
    },
    showLoginModal() {
      this.$refs['formData'].resetFields();
      this.$emit('show-login');
    }
  }
};
</script>
<style scoped>
  .el-form-item__content div div{
    text-align: center;
    width: 100% !important;
  }
</style>
